import React from 'react';
import { Button, Box, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { Privileges } from 'utils/privileges';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import EmptyPlatter from 'assets/icons/empty-platter.svg';
import { NonprofitEntityType } from 'entities/organization/model';

const AddNewChapterBlock = ({ setOpen }: { setOpen: (isOpen: boolean) => void }) => {
  const user = useSelector(selectUser);
  const organization = useSelector(selectOrganization);

  if (!user || !organization) {
    return null;
  }

  const canAddChapterRequests =
    organization.nonprofitEntityType === NonprofitEntityType.nonprofit &&
    user.hasPrivilege(Privileges.CHAPTERS_MANAGE);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
      }}
    >
      <div
        style={{
          padding: '0 150px 150px',
          background: `url("${EmptyPlatter}") no-repeat center bottom`,
          backgroundSize: 'contain',
        }}
      />
      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          style={{
            fontSize: 20,
            color: 'black',
          }}
        >
          This organization currently has no chapters
        </Typography>
      </Box>

      {canAddChapterRequests && (
        <>
          <Typography
            style={{
              marginTop: 0,
              fontSize: 16,
              color: 'darkgray',
            }}
          >
            Add a new chapter
          </Typography>

          <Button
            style={{
              color: 'black',
              borderColor: 'black',
            }}
            onClick={() => setOpen(true)}
          >
            Add
          </Button>
        </>
      )}
    </Box>
  );
};

export default AddNewChapterBlock;
